module.exports = __webpack_public_path__ + "img/5-4.fa1b7711.svg";